import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, WindIcon, MoonIcon, AppleIcon } from 'lucide-react';
export function WhatYouGet() {
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-294">
      <div className="max-w-5xl mx-auto px-4" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-296">
          <div className="text-center mb-12" data-id="element-297">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] mb-4" data-id="element-298">
              ¿Qué incluye el Protocolo?
            </h2>
            <p className="text-[#2D3436]/60 max-w-2xl mx-auto" data-id="element-299">
              Todo lo que necesitas para desinflamar tu vientre en una semana
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-300">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-301">
              <div className="flex items-start gap-4" data-id="element-302">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-303">
                  <BookOpenIcon className="w-6 h-6 text-[#C4A962]" data-id="element-304" />
                </div>
                <div data-id="element-305">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-306">
                    Guía Digital "Vientre Plano Post-30"
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-307">
                    El manual paso a paso para entender tu nuevo metabolismo y
                    cómo funciona la inflamación por cortisol.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-308">
              <div className="flex items-start gap-4" data-id="element-309">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-310">
                  <CalendarIcon className="w-6 h-6 text-[#C4A962]" data-id="element-311" />
                </div>
                <div data-id="element-312">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-313">
                    Plan de Acción de 7 Días
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-314">
                    Qué comer y qué evitar para ver resultados visuales en una
                    semana. Sin complicaciones ni recetas elaboradas.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-315">
              <div className="flex items-start gap-4" data-id="element-316">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-317">
                  <WindIcon className="w-6 h-6 text-[#C4A962]" data-id="element-318" />
                </div>
                <div data-id="element-319">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-320">
                    Técnica de Respiración Vago-Reset
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-321">
                    El interruptor de 2 minutos que detiene la hinchazón antes
                    de comer. Simple, rápido y efectivo.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-322">
              <div className="flex items-start gap-4" data-id="element-323">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-324">
                  <MoonIcon className="w-6 h-6 text-[#C4A962]" data-id="element-325" />
                </div>
                <div data-id="element-326">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-327">
                    Ritual Nocturno de Drenaje
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-328">
                    Un masaje linfático de 3 minutos para despertar deshinchada
                    cada mañana.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow md:col-span-2 md:max-w-md md:mx-auto" data-id="element-329">
              <div className="flex items-start gap-4" data-id="element-330">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-331">
                  <AppleIcon className="w-6 h-6 text-[#C4A962]" data-id="element-332" />
                </div>
                <div data-id="element-333">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-334">
                    Checklist de Alimentos Escudo
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-335">
                    Tu lista de supermercado anti-inflamatoria. Llévala contigo
                    y compra con confianza.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}